module.exports = __webpack_public_path__ + "static/media/about_pic_mess06.2df18640.jpg";